import script from "./SectionAwards.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionAwards.vue?vue&type=script&setup=true&lang=js"

import "./SectionAwards.vue?vue&type=style&index=0&id=21d18204&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d18204"]])

export default __exports__